import React from 'react';
import ModelReleaseFrontierChart from './ModelReleaseFrontierChart';
import SourceFooter from './SourceFooter';
import { datasetById } from './SectionElements';

const ModelReleaseFrontierSection = ({ datasets, range, isZh = false }) => {
    const dataset = datasetById(datasets, 'epoch_capabilities_index_models');

    return (
        <section className="ai-dev-overview" aria-labelledby="model-release-frontier-title">
            <div className="ai-dev-overview__intro">
                <div>
                    <span className="ai-dev-overview__eyebrow">EPOCH CAPABILITIES INDEX · ECI</span>
                    <h2 id="model-release-frontier-title">
                        {isZh ? 'Epoch 综合能力指数（ECI）' : 'Epoch Capabilities Index (ECI)'}
                    </h2>
                </div>
                <p>
                    {isZh
                        ? '每个点代表一个有可比 ECI 的模型；纵轴为 ECI 分数，横轴为发布日期。仅标注少数关键前沿模型。'
                        : 'Each point is a model with a comparable ECI score, plotted by score and release date. Only selected frontier models are labeled.'}
                </p>
            </div>
            <ModelReleaseFrontierChart dataset={dataset} range={range} isZh={isZh} />
            <p className="ai-dev-overview__scroll-hint">
                {isZh ? '左右滑动查看完整时间轴' : 'Swipe horizontally to inspect the full timeline'}
            </p>
            <SourceFooter dataset={dataset} isZh={isZh} />
        </section>
    );
};

export default ModelReleaseFrontierSection;
